// this is an autogenerated file from DesignSystem/AppsAssignConnection/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AppsAssignConnection($app_id: uuid!, $location_id: uuid!) {
  apps_connections(
    where: {
      app_id: { _eq: $app_id }
      resources: {
        resource_id: { _eq: $location_id }
        status: { _nin: [disabled] }
      }
      status: { _nin: [inactive, deleted] }
    }
  ) {
    id
    text: display_name
    updated_at
  }
}

`